import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
// emailjs import removed

const ContactStyles = () => {
  useEffect(() => {
    const css = `
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Sora:wght@400;500;600;700;800&display=swap');
      :root {
        --smooth-ease: cubic-bezier(0.4, 0, 0.2, 1);
        --bounce-ease: cubic-bezier(0.68, -0.55, 0.265, 1.55);
      }
      @keyframes fadeInUp { from { opacity: 0; transform: translateY(40px); } to { opacity: 1; transform: translateY(0); } }
      @keyframes slideInRight { from { opacity: 0; transform: translateX(40px); } to { opacity: 1; transform: translateX(0); } }
      .contact-container { padding: 120px 40px; max-width: 1280px; margin: 0 auto; background: linear-gradient(180deg, #fafbfc 0%, #ffffff 100%); font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
      .contact-header { font-family: 'Sora', sans-serif; font-size: 4.2rem; color: #0a1828; text-align: center; margin-bottom: 20px; font-weight: 700; letter-spacing: -1.5px; background: linear-gradient(135deg, #0a1828 0%, #004d73 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; animation: fadeInUp 0.8s var(--smooth-ease); }
      .contact-subtitle { text-align: center; font-size: 1.3rem; color: #4a5568; margin-bottom: 80px; font-weight: 400; letter-spacing: 0.3px; animation: fadeInUp 0.8s var(--smooth-ease) 0.1s; animation-fill-mode: backwards; }
      .contact-main-grid { display: grid; grid-template-columns: 1fr 1.3fr; gap: 50px; }
      .contact-info { background: linear-gradient(135deg, #ffffff 0%, rgba(107, 190, 68, 0.02) 100%); padding: 50px 40px; border-radius: 20px; box-shadow: 0 10px 40px rgba(0, 77, 115, 0.08); border: 1px solid rgba(0, 115, 177, 0.08); animation: fadeInUp 0.8s var(--smooth-ease) 0.2s; animation-fill-mode: backwards; transition: all 0.4s var(--smooth-ease); height: fit-content; }
      .contact-info:hover { transform: translateY(-8px); box-shadow: 0 20px 60px rgba(0, 77, 115, 0.12); }
      .contact-info-title { font-family: 'Sora', sans-serif; font-size: 2.5rem; color: #0a1828; margin-bottom: 20px; font-weight: 700; letter-spacing: -0.5px; }
      .contact-info-desc { font-size: 1.1rem; color: #4a5568; line-height: 1.8; margin-bottom: 40px; font-weight: 400; }
      .contact-info-list { list-style: none; padding: 0; margin: 0 0 40px 0; }
      .contact-info-item { display: flex; align-items: flex-start; gap: 18px; padding: 20px 0; border-bottom: 1px solid rgba(0, 115, 177, 0.08); font-size: 1.05rem; color: #2d3748; transition: all 0.3s var(--smooth-ease); }
      .contact-info-item:last-child { border-bottom: none; }
      .contact-info-item:hover { padding-left: 10px; color: #0073b1; }
      .contact-icon { font-size: 1.4rem; color: #6bbe44; min-width: 24px; margin-top: 2px; transition: all 0.3s var(--bounce-ease); }
      .contact-info-item:hover .contact-icon { transform: scale(1.2) rotate(5deg); color: #0073b1; }
      .contact-label { font-weight: 600; color: #1a365d; display: block; margin-bottom: 4px; }
      .inquiry-form { animation: slideInRight 0.8s var(--smooth-ease) 0.3s; animation-fill-mode: backwards; }
      .inquiry-form-title { font-family: 'Sora', sans-serif; font-size: 2.5rem; color: #0a1828; margin-bottom: 35px; font-weight: 700; letter-spacing: -0.5px; }
      .contact-form { background: white; padding: 45px; border-radius: 20px; box-shadow: 0 10px 40px rgba(0, 77, 115, 0.08); border: 1px solid rgba(0, 115, 177, 0.08); transition: all 0.4s var(--smooth-ease); }
      .contact-form:hover { box-shadow: 0 20px 60px rgba(0, 77, 115, 0.12); }
      .form-group { margin-bottom: 28px; }
      .form-label { display: block; font-size: 0.85rem; font-weight: 600; color: #1a365d; margin-bottom: 10px; letter-spacing: 0.3px; text-transform: uppercase; }
      .form-input, .form-select, .form-textarea { width: 100%; padding: 16px 18px; font-size: 1.05rem; border: 2px solid rgba(0, 115, 177, 0.12); border-radius: 12px; font-family: 'Inter', sans-serif; color: #2d3748; background: #fafbfc; transition: all 0.3s var(--smooth-ease); box-sizing: border-box; }
      .form-input:focus, .form-select:focus, .form-textarea:focus { outline: none; border-color: #6bbe44; background: white; box-shadow: 0 0 0 4px rgba(107, 190, 68, 0.1); transform: translateY(-2px); }
      .form-textarea { resize: vertical; min-height: 140px; }
      .submit-button { width: 100%; padding: 18px 40px; font-size: 1.15rem; font-weight: 600; color: white; background: linear-gradient(135deg, #6bbe44 0%, #5aa838 100%); border: none; border-radius: 12px; cursor: pointer; transition: all 0.4s var(--bounce-ease); font-family: 'Inter', sans-serif; letter-spacing: 0.5px; text-transform: uppercase; box-shadow: 0 6px 20px rgba(107, 190, 68, 0.3); position: relative; overflow: hidden; }
      .submit-button::before { content: ''; position: absolute; top: 0; left: -100%; width: 100%; height: 100%; background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent); transition: left 0.5s var(--smooth-ease); }
      .submit-button:hover::before { left: 100%; }
      .submit-button:hover { transform: translateY(-4px) scale(1.02); box-shadow: 0 10px 30px rgba(107, 190, 68, 0.4); background: linear-gradient(135deg, #5aa838 0%, #4a9630 100%); }
      .submit-button:active { transform: translateY(-2px) scale(1.01); }
      /* Honeypot field: visually hidden from sighted users, but present in the
         DOM so simple bots that auto-fill all form fields will trip it.
         Uses off-screen positioning (not display:none/visibility:hidden)
         because some bots specifically skip fields hidden that way. */
      .hp-field-wrapper { position: absolute; left: -9999px; top: -9999px; width: 1px; height: 1px; overflow: hidden; }
      @media (max-width: 1024px) { .contact-main-grid { grid-template-columns: 1fr; gap: 40px; } }
      @media (max-width: 768px) { .contact-container { padding: 80px 24px; } .contact-header { font-size: 3.2rem; } .contact-subtitle { font-size: 1.1rem; margin-bottom: 60px; } .contact-info, .contact-form { padding: 35px 25px; } .contact-info-title, .inquiry-form-title { font-size: 2rem; } .form-input, .form-select, .form-textarea { padding: 14px 16px; } }
      @media (max-width: 480px) { .contact-header { font-size: 2.6rem; } .contact-info, .contact-form { padding: 30px 20px; } .social-media-links { gap: 12px; } .social-icon { width: 45px; height: 45px; font-size: 1.1rem; } }
    `;

    const styleEl = document.createElement('style');
    styleEl.id = 'contact-styles';
    styleEl.textContent = css;
    document.head.appendChild(styleEl);

    return () => {
      const el = document.getElementById('contact-styles');
      if (el) {
        document.head.removeChild(el);
      }
    };
  }, []);

  return null;
};

function Contact() {
  const [status, setStatus] = useState('Send Message');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    product: '',
    quantity: '',
    message: '',
    website: '' // honeypot field — real users never see or fill this
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // --- HONEYPOT CHECK ---
    // If the hidden "website" field has any value, a bot filled it in.
    // Silently pretend success and stop here — no network request is made,
    // so this costs zero Cloud Function invocations.
    if (formData.website.trim() !== '') {
      setStatus('Message Sent!');
      setFormData({
        name: '',
        email: '',
        product: '',
        quantity: '',
        message: '',
        website: ''
      });
      setTimeout(() => setStatus('Send Message'), 3000);
      return;
    }

    setStatus('Sending...');

    const FUNCTION_URL = "https://send-contact-email-bmqfdmicpa-uc.a.run.app";
    try {
      // Only send the real fields to the backend — no need to forward the honeypot value.
      const { website, ...payload } = formData;

      const response = await fetch(FUNCTION_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setStatus('Message Sent!');
        alert('Thank you for your inquiry! We will get back to you soon.');
        setFormData({
          name: '',
          email: '',
          product: '',
          quantity: '',
          message: '',
          website: ''
        });
        setTimeout(() => setStatus('Send Message'), 3000);
      } else {
        throw new Error(result.error || 'Failed to send message');
      }
    } catch (error) {
      console.error('Submission Error:', error);
      setStatus('Send Failed');
      alert('An error occurred while sending your message. Please try again later.');
      setTimeout(() => setStatus('Send Message'), 3000);
    }
  };

  return (
    <>
      <ContactStyles />
      <div className="contact-container">
        <h2 className="contact-header">Contact Us</h2>
        <p className="contact-subtitle">
          We're here to answer any questions you may have. Reach out and we'll respond as soon as we can.
        </p>

        <div className="contact-main-grid">
          <section className="contact-info">
            <h3 className="contact-info-title">Get in Touch</h3>
            <p className="contact-info-desc">Connect with us through any of these channels. We're always ready to assist you.</p>
            <ul className="contact-info-list">
              <li className="contact-info-item">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="contact-icon" />
                <div>
                  <span className="contact-label">Address:</span>
                  Egypt
                </div>
              </li>
              <li className="contact-info-item">
                <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                <div>
                  <span className="contact-label">Email:</span>
                  info@rafferty.com
                </div>
              </li>
            </ul>
          </section>

          <section className="inquiry-form">
            <h3 className="inquiry-form-title">Send Us an Inquiry</h3>
            
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name" className="form-label">Your Name</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  className="form-input"
                  value={formData.name}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <label htmlFor="email" className="form-label">Your Email</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  className="form-input"
                  value={formData.email}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <label htmlFor="product" className="form-label">Product of Interest</label>
                <select 
                  id="product" 
                  name="product"
                  className="form-select"
                  value={formData.product}
                  onChange={handleChange}
                >
                  <option value="">Select a product</option>
                  <option value="flowers">Flowers</option>
                  <option value="leaves">Leaves</option>
                  <option value="seeds">Seeds</option>
                  <option value="roots">Roots</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="quantity" className="form-label">Quantity / Volume</label>
                <input 
                  type="text" 
                  id="quantity" 
                  name="quantity"
                  className="form-input"
                  value={formData.quantity}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="message" className="form-label">Your Message</label>
                <textarea 
                  id="message" 
                  name="message" 
                  rows="6"
                  className="form-textarea"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              {/* Honeypot field — hidden from sighted and screen-reader users.
                  tabIndex=-1 keeps it out of keyboard tab order, autoComplete="off"
                  discourages browser autofill, and the name "website" is a classic
                  bait field bots love to fill. */}
              <div className="hp-field-wrapper" aria-hidden="true">
                <label htmlFor="website">Website</label>
                <input
                  type="text"
                  id="website"
                  name="website"
                  tabIndex="-1"
                  autoComplete="off"
                  value={formData.website}
                  onChange={handleChange}
                />
              </div>
              
              <button type="submit" className="submit-button">
                {status}
              </button>
            </form>
          </section>
        </div>
      </div>
    </>
  );
}

export default Contact;